module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicon.ico
// module id = 253
// module chunks = 0